import { useContext } from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileExport, faFileImport, faUser } from '@fortawesome/pro-light-svg-icons'

import { Button, Tools } from '@domain-group/suit-theme'

import useReporting from '@hooks/useReporting'

import PageContext from '@contexts/pageContext'

const UsersTools = (props) => {
  const { pageFilters } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      generateReport,
      showFindAgentModal,
      showImportUsersModal,
    },
  } = pageContext

  const reportingPayload = useReporting({
    allowedReports: ['user_details'],
    formDeps: [pageFilters],
    defaultValues: pageFilters,
  })

  const {
    callbacks: { generateReport: generateFn },
  } = reportingPayload

  const generateReportPayload = {
    callbacks: {
      action: generateFn,
    },
    toastText: 'Report Queued',
  }

  return (
    <Tools>
      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faUser} />}
        onClick={() => showFindAgentModal()}
        size="medium"
      >
        Find Agent
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faFileImport} />}
        marginTop="medium"
        onClick={() => showImportUsersModal()}
        size="medium"
      >
        Import Users
      </Button>

      <Button
        buttonStyle="secondaryUtility"
        icon={<FontAwesomeIcon icon={faFileExport} />}
        marginTop="medium"
        onClick={() => generateReport(generateReportPayload)}
        size="medium"
      >
        Export Users
      </Button>
    </Tools>
  )
}

UsersTools.propTypes = {
  pageFilters: PropTypes.object.isRequired,
}

export default UsersTools
